module.exports = {"admin":"Admin","global-admin":"Global Admin","home":"Home","login":"Login","logout":"Logout","reports":"Reports"}